import 'unfetch/polyfill';
import { ENVIRONMENT } from '../../environment';
import { reduxStore } from '.';
/* Seperate from DIY for now so that it does not persist in LocalStorage. */

const START_YEAR = 1968;
const END_YEAR = 2019;

const autoYears = [...Array(END_YEAR - START_YEAR + 1)]
  .map((_, i) => START_YEAR + i)
  .reverse();

export const autoData = {
  autoYears,
  autoMakes: {},
  autoModels: {},
};

export const updateAutoMakes = (year, makes) => ({
  type: 'UPDATE_AUTO_MAKES',
  year,
  makes,
});

export const updateAutoModels = (make, models) => ({
  type: 'UPDATE_AUTO_MODELS',
  make,
  models,
});

export const autoDataReduccer = ({ autoData, ...state }, action) => {
  switch (action.type) {
    case 'UPDATE_AUTO_MAKES': {
      const { year, makes } = action;
      return {
        ...state,
        autoData: {
          ...autoData,
          autoMakes: {
            ...autoData.autoMakes,
            [year]: makes,
          },
        },
      };
    }
    case 'UPDATE_AUTO_MODELS': {
      const { make, models } = action;
      return {
        ...state,
        autoData: {
          ...autoData,
          autoModels: {
            ...autoData.autoModels,
            [make]: models,
          },
        },
      };
    }
    default:
      return undefined;
  }
};

const fetchJson = (state, path) => {
  const {
    user: { id },
    sessionHeaders,
  } = state;
  const envHeaders = ENVIRONMENT.endpoints.rest.headers || {};
  const restHeader = { 'user-id': id };

  return fetch(`${ENVIRONMENT.endpoints.rest.url}/${path}`, {
    method: 'GET',
    mode: 'cors',
    headers: {
      ...sessionHeaders,
      ...envHeaders,
      ...restHeader,
    },
  }).then(response => response.json());
};

const _getAutoMakes = (year, dispatch, getState = reduxStore().getState) => {
  const {
    autoData: { autoMakes },
    ...state
  } = getState();

  if (autoMakes[year]) {
    return; // no update needed.
  }

  fetchJson(state, `carquery/makes/${year}`).then(data => {
    dispatch(updateAutoMakes(year, data));
  });
};

export const getAutoMakes = year => _getAutoMakes.bind(null, year);

const _getAutoModels = (
  year,
  make,
  dispatch,
  getState = reduxStore().getState
) => {
  const {
    autoData: { autoModels },
    ...state
  } = getState();

  if (autoModels[make]) {
    return; // no update needed.
  }

  fetchJson(state, `carquery/models/${year}/${make}`).then(data => {
    dispatch(updateAutoModels(make, data));
  });
};

export const getAutoModels = (year, make) =>
  _getAutoModels.bind(null, year, make);
